import { CommonFormGrid } from 'components/form/grid';
import { FormHeading } from 'components/form/heading';
import { FormSelect } from 'components/form/select';
import { FormTextField } from 'components/form/textfield';
import { EB } from 'components/layout/error-boundary';
import { FormContext } from 'contexts/form';
import { UserDoc } from 'lib/interfaces/database/user';
import { useContext, useState } from 'react';

export const UserForm = () => {
  const { data, setData } = useContext(FormContext);

  const [safeData] = useState(() => {
    const output: Partial<UserDoc> = data;
    delete output.password;
    return output;
  });

  return (
    <EB>
      <CommonFormGrid columns="2">
        <FormHeading label="User" gridColumn="span 2" />

        <FormTextField
          label="First Name"
          defaultValue={safeData.firstName}
          onChange={(v) => {
            const payload: Partial<UserDoc> = {
              firstName: v,
            };
            setData(payload);
          }}
        />

        <FormTextField
          label="Last Name"
          defaultValue={safeData.lastName}
          onChange={(v) => {
            const payload: Partial<UserDoc> = {
              lastName: v,
            };
            setData(payload);
          }}
        />

        <FormTextField
          label="Email"
          type="email"
          defaultValue={safeData.email}
          onChange={(v) => {
            const payload: Partial<UserDoc> = {
              email: v,
            };
            setData(payload);
          }}
        />

        {!safeData.investorID && (
          // investors should never be granted admin access
          <FormSelect
            label="Admin Access"
            defaultValue={safeData.isAdmin?.toString()}
            disabled={!!safeData.investorID}
            options={[
              { label: 'Admin', value: 'true' },
              { label: 'User', value: 'false' },
            ]}
            onBooleanChange={(v) => {
              const payload: Partial<UserDoc> = {
                isAdmin: v,
              };
              setData(payload);
            }}
          />
        )}

        <FormTextField
          gridColumnStart="1"
          label="Password"
          type="password"
          onPasswordChange={(v) => {
            const payload: Partial<UserDoc> = {
              password: v,
            };
            setData(payload);
          }}
          // a password is required for new users
          required={!safeData.id}
        />
      </CommonFormGrid>
    </EB>
  );
};
